import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

// Componentler
import CatalogHero from './CatalogHero/CatalogHero';
import CategoryGrid from './CategoryGrid/CategoryGrid';
import ProductGrid from './ProductGrid/ProductGrid';
import Navbar from '../Navbar/Navbar';
import ExportPortfolio from '../ExportPortfolio/ExportPortfolio';

// CSS ve Dil Hooku
import './CatalogSystem.css';
import { useLanguage } from '../../context/LanguageContext';

const CatalogSystem = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [translatedTitles, setTranslatedTitles] = useState({}); // Kanka başlıklar için cache
  const { t, lang } = useLanguage();

  // ANLIK ÇEVİRİ MOTORU (BAŞLIKLAR İÇİN)
  const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'TR') return text;
    const cacheKey = `${text}_${targetLang}`;
    if (translatedTitles[cacheKey]) return translatedTitles[cacheKey];

    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=${targetLang.toLowerCase()}&dt=t&q=${encodeURI(text)}`
      );
      const data = await response.json();
      const result = data[0][0][0];
      setTranslatedTitles(prev => ({ ...prev, [cacheKey]: result }));
      return result;
    } catch (error) {
      return text;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const catSnapshot = await getDocs(collection(db, "categories"));
        const catItems = catSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCategories(catItems.sort((a, b) => (a.order || 0) - (b.order || 0)));

        const prodSnapshot = await getDocs(collection(db, "products"));
        const prodItems = prodSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProducts(prodItems);
      } catch (error) {
        console.error("Firebase Hatası:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Dil değiştiğinde kategori başlıklarını çevir
  useEffect(() => {
    if (lang !== 'TR' && categories.length > 0) {
      categories.forEach(cat => translateText(cat.title, lang));
    }
  }, [categories, lang]);

  const getTitle = (originalTitle) => {
    const cacheKey = `${originalTitle}_${lang}`;
    return translatedTitles[cacheKey] || originalTitle;
  };

  return (
    <div className="catalog-page">
      <Navbar />
      <CatalogHero />

      {loading ? (
        <div className="loader-container">
          <span className="loading-spinner"></span>
          {/* Loading metni dile göre değişir */}
          <p>{t('catalog.system.loading') || "Katalog Hazırlanıyor..."}</p>
        </div>
      ) : (
        <>
          <CategoryGrid id="category-grid-anchor" categories={categories} products={products} />

          <div id="product-list-anchor" className="catalog-sections-wrapper">
            {categories.map((cat) => {
              const filteredProducts = products.filter(p => p.categoryId === cat.id);
              if (filteredProducts.length === 0) return null;

              return (
                <div key={cat.id} id={`section-${cat.id}`} className="category-section-group">
                  <div className="category-section-header">
                    {/* Kanka buradaki başlıklar artık anlık çevriliyor */}
                    <span className="cat-badge">{getTitle(cat.title)}</span>
                    <h2 className="cat-title">{getTitle(cat.title)}</h2>
                  </div>
                  
                  <ProductGrid products={filteredProducts} />
                </div>
              );
            })}
          </div>
          <ExportPortfolio />
        </>
      )}
    </div>
  );
};

export default CatalogSystem;